import {t} from '@lingui/core/macro';

import {useMonitorToggle} from 'entities/monitor';
import {serverAPI} from 'features/server/api/serverAPI';
import {isServerPaused} from 'features/server/lib/serverStatusHelper';

import IServerOutput from './Server/IServer';

export const useServerToggle = (
    item: Pick<IServerOutput, 'uuid' | 'status'>,
    onLimit: () => void,
) => {
    const [pauseServer] = serverAPI.usePauseServerMutation();
    const [resumeServer] = serverAPI.useResumeServerMutation();
    const isPaused = isServerPaused(item.status);

    return useMonitorToggle({
        isActive: !isPaused,
        isPaused,
        pause: () => pauseServer(item.uuid).unwrap(),
        resume: () => resumeServer(item.uuid).unwrap(),
        pausedText: t`Сервер поставлен на паузу`,
        resumedText: t`Сервер возобновлён`,
        onLimit,
    });
};

export default useServerToggle;
